import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import MessageArea from '@ui-parts/MessageArea';
import { PALETTE, ADMIN_PALETTE } from '~/assets/styles/base';
import { initialize } from '~/features/passwordReset/passwordResetSlice';

const MessageAreaWrapper = styled.div`
  max-width: 706px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 58px auto 0;
`;

const StyledForwardToInboxOutlinedIcon = styled(ForwardToInboxOutlinedIcon)`
  color: ${ADMIN_PALETTE.primary.main};
  font-size: 4.8rem;
  margin-top: 6px;
`;

const AdminPasswordResetSendMailCompleted: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // isCompletedフラグを初期化
  useEffect(() => {
    dispatch(initialize());
  }, []);

  return (
    <MessageAreaWrapper>
      <MessageArea
        title={t('adminMessage.passwordResetMail.title')}
        message={t('adminMessage.passwordResetMail.message')}
        desc={t('adminMessage.passwordResetMail.desc')}
      >
        <StyledForwardToInboxOutlinedIcon />
      </MessageArea>
    </MessageAreaWrapper>
  );
};

export default AdminPasswordResetSendMailCompleted;
